import {
    CALL_SMS_TEMPLATE,
    FETCH_ALL_SMS_TEMPLATE,
    FETCH_ALL_EMAIL_TEMPLATE,
    CALL_EMAIL_TEMPLATE
} from './actions';

export default function reducer(
    state = {
        isCallEmailTemplate: true,
        isCallSMSTemplate: true,
        allEmailTemplate: [],
        allSMSTemplate: [],
    },
    action
) {
    switch (action.type) {
        case CALL_SMS_TEMPLATE:
            return {
                ...state,
                isCallSMSTemplate: action.payload.data,
            };
        case FETCH_ALL_SMS_TEMPLATE:
            return {
                ...state,
                allSMSTemplate: action.payload.data,
            };
        case CALL_EMAIL_TEMPLATE:
            return {
                ...state,
                isCallEmailTemplate: action.payload.data,
            };
        case FETCH_ALL_EMAIL_TEMPLATE:
            return {
                ...state,
                allEmailTemplate: action.payload.data,
            };
        default:
            return state;
    }
    // return state;
}
